import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { updateCampaignDayBudgetInfoRemote } from '../../actions/campaigns-grid';
import {
    GridCampaignDayBudgetCell,
    GridCampaignDayBudgetCellProps
} from '../../components/GridCampaignDayBudgetCell/GridCampaignDayBudgetCell';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { getEditCellKey } from '../../service/GridHelpers/GridHelpers';
import { DayBudgetValue, WalletDayBudgetValue } from '../../typings/budget';
import { DailyBudgetLimit } from '../../typings/constants';
import { CurrencyCode } from '../../typings/graphql-grid';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    value?: DayBudgetValue;
    editable: boolean;
    currency: CurrencyCode;
    agencyId: string | null;
    campaignId: string;
    dailyBudgetLimit: DailyBudgetLimit;
    columnName: string;
    login: string;
    walletBudget?: WalletDayBudgetValue;
}

export type StateProps = TStateProps<GridCampaignDayBudgetCellProps, OwnProps>;

export type DispatchProps = TDispatchProps<
    GridCampaignDayBudgetCellProps,
    OwnProps
>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editCellsData, isGridScrolling, isCompactViewEnabled } = state.grid;
    const { campaignId, columnName } = ownProps;
    const { view } = selectGridSourceParams(state);
    const key = getEditCellKey({
        id: campaignId,
        column: columnName,
        view
    });
    const isSaving =
        editCellsData[key] !== undefined ? editCellsData[key].isSaving : false;
    const error =
        editCellsData[key] !== undefined
            ? (editCellsData[key].error as string)
            : undefined;

    return {
        isSaving,
        error,
        isGridScrolling,
        isCompactViewEnabled
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<Action>,
    ownProps: OwnProps
): DispatchProps => {
    const { columnName, campaignId, login } = ownProps;
    return {
        saveDayBudget: (value: DayBudgetValue) => {
            dispatch(
                updateCampaignDayBudgetInfoRemote(
                    {
                        campaignId,
                        value
                    },
                    login,
                    columnName
                )
            );
        }
    };
};

export const EditableCampaignDateBudgetCellContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps
>(
    mapStateToProps,
    mapDispatchToProps
)(GridCampaignDayBudgetCell);
